@if (shared.rights) {
  <div class="iframe-container d-flex h-100">
    <iframe id="iframe-app" [src]="appPath | safe" allowfullscreen class="w-100 min-h-100" (load)="onIframeLoaded()" allow="camera;"></iframe>
  </div>
}
